module.exports = __webpack_public_path__ + "91bf6ab95fb27eef9658b8396020686a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/pap_testimonial-4-author.jpg
// module id = 3074
// module chunks = 2